export class Configuration {
  discoveryDocumentConfigUrl: string;
  redirectUri: string;
  responseType: string;
  issuer: string;
  strictDiscoveryDocumentValidation: boolean;
  tokenEndpoint: string;
  loginUrl: string;
  url: string;
  clientId: string;
  scope: string;
  skipIssuerCheck: boolean;
  clearHashAfterLogin: boolean;
  oidc: boolean;
  postLogoutRedirectUri: string;
  baseUrl: string;
  subscriptionURL: string;
  subscriptionUrl2: string;
  productId: string;
  apiEndpoint: string;
  apiEndpointforchecksubcription: any;
  commonApi: string;
  constructor(init?: Partial<Configuration>) {
    Object.assign(this, init);
  }
}
